import { useStateMachine } from 'little-state-machine';
import { setEnrichmentFrom, clearEnrichmentFrom } from '../Components/AdvancedSearch/enrichmentActions';

export const useEnrichmentState = () => {
  const { state, actions } = useStateMachine({
    actions: { setEnrichmentFrom, clearEnrichmentFrom },
  });

  return {
    enrichmentFrom: state.enrichmentFrom,
    setEnrichmentFrom: actions.setEnrichmentFrom,
    clearEnrichmentFrom: actions.clearEnrichmentFrom,
  };
};
